// *************************************
// MATERIAL-UI (v4)
// *************************************

import {
  Box as MuiBox,
  Grid as MuiGrid
} from '@material-ui/core';

// Autocomplete
import {
  StyledAutocomplete
} from './mui-autocomplete';

// Buttons
import {
  StyledButtonCTA,
  StyledButtonLink,
  StyledButtonText
} from './mui-button';

// Checkbox
import {
  StyledCheckbox,
  StyledCheckboxLabel
} from './mui-checkbox';

// Dialogs
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  StyledDialogBoxIcon,
  StyledDialogBoxClose,
} from './mui-dialog';

// Divider
import {
  StyledDivider
} from './mui-divider';

// Icon Button
import {
  StyledButtonIcon
} from './mui-iconbutton';

// FAB Button
import {
  StyledButtonFAB
} from './mui-fab';

// Menu
import {
  StyledMenuItem,
  StyledMenuHeader,
  StyledList,
  StyledListItem,
  StyledListItemIcon
} from './mui-menu';

// Popover
import {
  StyledPopover
} from './mui-popover';

// Radio
import {
  StyledRadio,
  StyledRadioGroup,
  StyledRadioLabel
} from './mui-radio';

// Sliders
import {
  StyledSlider,
} from './mui-slider';

// Switch
import {
  StyledSwitchLabel,
  StyledSwitch
} from './mui-switch';

// Tabs
import {
  StyledTabs,
  StyledTabsSwipeable,
  StyledTab
} from './mui-tabs';

// TextFields
import {
  StyledTextField,
  StyledTextFieldIcon,
  StyledSelectOption,
  StyledInputSlider
} from './mui-textfield';

// Tooltip
import {
  StyledTooltipLight
} from './mui-tooltip';

// *************************************
// MATERIAL-UI Pickers
// *************************************

// TimePicker
import {
  StyledTimePicker
} from '../mui-pickers/mui-timepicker';

// DatePicker
import {
  StyledDatePicker
} from '../mui-pickers/mui-datepicker';

// DatetimePicker
import {
  StyledDateTimePicker
} from '../mui-pickers/mui-datetimepicker';

export const MUI = {
  Autocomplete: StyledAutocomplete,
  Box: MuiBox,
  ButtonCTA: StyledButtonCTA,
  ButtonFAB: StyledButtonFAB,
  ButtonLink: StyledButtonLink,
  ButtonIcon: StyledButtonIcon,
  ButtonText: StyledButtonText,
  Checkbox: StyledCheckbox,
  CheckboxLabel: StyledCheckboxLabel,
  DatePicker: StyledDatePicker,
  DateTimePicker: StyledDateTimePicker,
  Dialog: StyledDialog,
  DialogTitle: StyledDialogTitle,
  DialogContent: StyledDialogContent,
  DialogActions: StyledDialogActions,
  DialogBoxIcon: StyledDialogBoxIcon,
  DialogBoxClose: StyledDialogBoxClose,
  Divider: StyledDivider,
  Grid: MuiGrid,
  InputSlider: StyledInputSlider,
  MenuHeader: StyledMenuHeader,
  MenuItem: StyledMenuItem,
  List: StyledList,
  ListItem: StyledListItem,
  ListItemIcon: StyledListItemIcon,
  Popover: StyledPopover,
  Radio: StyledRadio,
  RadioGroup: StyledRadioGroup,
  RadioLabel: StyledRadioLabel,
  Slider: StyledSlider,
  Switch: StyledSwitch,
  SwitchLabel: StyledSwitchLabel,
  Tabs: StyledTabs,
  TabsSwipeable: StyledTabsSwipeable,
  Tab: StyledTab,
  TextField: StyledTextField,
  TextFieldIcon: StyledTextFieldIcon,
  TimePicker: StyledTimePicker,
  SelectOption: StyledSelectOption,
  Tooltip: StyledTooltipLight
};